import * as Yup from 'yup';
import { ASSISTANT_TYPES, mapScoutTabsToAssistantCategories } from '../../../constants';

export const generationYopValidation = (scoutTab) => {
  return Yup.object().shape({
    byPass: Yup.string(),
    focusOn: Yup.string(),
    fileText: Yup.string(),
    url: Yup.string().when('channels', ([channels], schema) => {
      const tabAssistantValue = channels[mapScoutTabsToAssistantCategories[scoutTab]].assistant;
      if (tabAssistantValue.type === ASSISTANT_TYPES.TEXT) {
        return schema.required('required');
      } else {
        return schema.nullable();
      }
    }),
    docs: Yup.mixed().nullable(),
  });
};
